'use client';

import { ValueOf } from 'type-fest';

import { HUB_URL } from './const';
import { useSignalRHub } from './context/useSignalRHub';

export const IothubEvent = {
  RECEIVE_TOPIC_RELAY: 'ReceiveTopicRelay',
} as const;

export type IothubEvent = ValueOf<typeof IothubEvent>;

/**
 * Hook to use for the Iothub hub
 *
 */
export function useIothubHub() {
  return useSignalRHub(HUB_URL.IOTHUB);
}
